import React from "react";
import Icon from "../Icon";
import { IconSize } from "../Icon/Icon";

interface Props {
  type: "up" | "down" | "left" | "right";
  size?: IconSize;
}
const ChevronIcon = ({ type, size = "medium" }: Props) => {
  const getRotate = () => {
    const rotate = {
      up: 270,
      down: 90,
      left: 180,
      right: 0,
    };
    return rotate[type];
  };

  return (
    <Icon
      name="chevronRightSmall"
      size={size}
      fill="palette.neutral.x0"
      rotate={getRotate()}
    />
  );
};

export default ChevronIcon;
